import { render, staticRenderFns } from "./LGPDAlert.vue?vue&type=template&id=059b2beb&scoped=true&"
import script from "./LGPDAlert.vue?vue&type=script&lang=js&"
export * from "./LGPDAlert.vue?vue&type=script&lang=js&"
import style0 from "./LGPDAlert.vue?vue&type=style&index=0&id=059b2beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b2beb",
  null
  
)

export default component.exports